.thread-list {
  display: grid;
  grid-template-rows: auto 1fr auto auto;
  height: 100%;
  overflow: auto;
}

.thread-list-header {
  padding: var(--mantine-spacing-xs);
  border-bottom: 1px solid var(--mantine-color-dark-4);
}

.thread-list-items {
  overflow: auto;
}

.thread-list-item {
  display: flex;
  gap: var(--mantine-spacing-sm);
  align-items: center;
  padding: calc(var(--mantine-spacing-xs) * 0.5) var(--mantine-spacing-sm);
  cursor: pointer;
  border-radius: var(--mantine-radius-sm);
  &[data-active] {
    background: var(--mantine-color-dark-6);
  }
  &:not([data-active]):hover {
    background: alpha(var(--mantine-color-dark-6), 0.5);
  }
}

.thread-list-item-trigger {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--mantine-font-size-sm);
  text-align: left;
  white-space: nowrap;
  cursor: pointer;
  background: transparent;
  border: none;
}

.thread-list-footer {
  display: grid;
  row-gap: var(--mantine-spacing-md);
  padding: var(--mantine-spacing-md);
  border-top: 1px solid var(--mantine-color-dark-4);
}
